import React from "react";
import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const BenefitPoint: React.FC<{
    name: string;
    className?: string;
}> = ({ name, className }) => {
    return (
        <div className='mr-8 mb-8'>
            <div className={'flex items-center mx-4 ' + className}>
                <div className='mr-4 my-1'>
                    <FontAwesomeIcon icon={faCircle} style={{ color: '#0D9488' }}></FontAwesomeIcon>
                </div>
                {name}
            </div>
        </div>
    )
}
